// STAGING: use stgfeapi.prowa.it as the API endpoint for staging
export const API_URL = "https://feapi.prowa.it/api/V1"; //"https://feapi.prowa.it/api/V1";
export const NOTIFICATION_STATE_NAME = "notification_state"; //localStorage for the notification state
export const DOWNLOAD_STATE_NAME = "download_state"; //localStorage for the download state
export const LAST_ACCESS_NAME = "last_access"; //localStorage for the last access date
export const APP_KEY_NAME = "prowa_app_key"; //localStorage for the app key
export const UID_NAME = "prowa_uid"; //localStorage for the user uid
export const UPDATE_APP_TIME = 4 * 60 * 1000;
export const TIME_TO_RESHOW_DOWNLOAD_MODAL = 24 * 60 * 60 * 1000; //show modal for the download of the pwa after x seconds from when user decline the installation
export const TIME_TO_SHOW_HOME_MODALS = 5000; //show modal after x seconds from when user open the app
export const TIME_TO_RESHOW_NOTIFICATION_MODAL = 3 * 24 * 60 * 60 * 1000; //show modal after x seconds from when user decline the notification subscription
export const SHOPCHAT_JS_URL = 'https://chat.shopchat.it/static/embed.js';
export const MENU = [
  { path: '/', icon: 'home' },
  { path: '/info', icon: 'info' },
  { path: '/proposte', paths: ['proposte', 'proposta'], icon: 'web_stories' },
  { path: '/sedi', paths: ['sedi', 'sede'], icon: 'map' },
  { path: '/help', icon: 'help_outline' },
];